import { render } from "./Exhibit.vue?vue&type=template&id=854cebec&scoped=true"
import script from "./Exhibit.vue?vue&type=script&lang=js"
export * from "./Exhibit.vue?vue&type=script&lang=js"

import "./Exhibit.vue?vue&type=style&index=0&id=854cebec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854cebec"]])

export default __exports__